import {
	OPERATIONAL_EVENT_TYPE,
	SCREEN_EVENT_TYPE,
	TRACK_EVENT_TYPE,
	UI_EVENT_TYPE,
} from '@atlaskit/analytics-gas-types';

import type { ScreenAnalyticsPayload, NonScreenAnalyticsPayload } from '../types';

import type { FireAnalyticsPayload } from './analyticsHooks';
import type { CommonAttributes } from './commonAttributes';

type CustomNonScreenAnalyticsPayload = Omit<NonScreenAnalyticsPayload, 'eventType'>;

type CustomScreenAnalyticsPayload = Omit<ScreenAnalyticsPayload, 'eventType'>;

/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */
export class BaseInvitePeopleAnalytics {
	private readonly fireAnalytics: FireAnalyticsPayload;
	protected readonly commonAttributes!: CommonAttributes;

	constructor(fireAnalytics: FireAnalyticsPayload, attributes: CommonAttributes) {
		this.fireAnalytics = fireAnalytics;
		this.setCommonAttributes(attributes);
	}

	setCommonAttributes(attributes: CommonAttributes): void {
		(this.commonAttributes as CommonAttributes) = attributes;
	}

	protected fireUI(payload: CustomNonScreenAnalyticsPayload): void {
		this.fireAnalytics({ ...payload, eventType: UI_EVENT_TYPE });
	}

	protected fireTrack(payload: CustomNonScreenAnalyticsPayload): void {
		this.fireAnalytics({ ...payload, eventType: TRACK_EVENT_TYPE });
	}

	protected fireOperational(payload: CustomNonScreenAnalyticsPayload): void {
		this.fireAnalytics({ ...payload, eventType: OPERATIONAL_EVENT_TYPE });
	}

	protected fireScreen(payload: CustomScreenAnalyticsPayload): void {
		this.fireAnalytics({ ...payload, eventType: SCREEN_EVENT_TYPE });
	}
}

/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */
export type AnalyticsClassConstructor<Instance extends BaseInvitePeopleAnalytics> = new (
	fireAnalytics: FireAnalyticsPayload,
	commonAttributes: CommonAttributes,
) => Instance;
